// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function name(t) {
  return t.name;
}

function reportLogicId(t) {
  return t.reportLogicId;
}

function setReportLogicId(id, t) {
  return {
          name: t.name,
          reportLogicId: id
        };
}

function empty(param) {
  return {
          name: "",
          reportLogicId: undefined
        };
}

function decode(json) {
  return {
          name: Json_decode.field("name", Json_decode.string, json),
          reportLogicId: Json_decode.field("organization_custom_report_id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json)
        };
}

var templateType = "CustomReport";

exports.name = name;
exports.reportLogicId = reportLogicId;
exports.setReportLogicId = setReportLogicId;
exports.templateType = templateType;
exports.empty = empty;
exports.decode = decode;
/* No side effect */
